import { render } from "./IQResults.vue?vue&type=template&id=d30cb344&scoped=true"
import script from "./IQResults.vue?vue&type=script&lang=js"
export * from "./IQResults.vue?vue&type=script&lang=js"

import "./IQResults.vue?vue&type=style&index=0&id=d30cb344&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-d30cb344"

export default script